import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Award, Gift } from "lucide-react";

const TIER_STYLE = {
  Silver:   { chip: "bg-slate-500/15 border-slate-400/40 text-slate-100",     icon: "text-slate-300",   dot: "bg-slate-400" },
  Gold:     { chip: "bg-amber-500/15 border-amber-400/50 text-amber-100",     icon: "text-amber-300",   dot: "bg-amber-400" },
  Platinum: { chip: "bg-pink-500/15 border-pink-400/50 text-pink-100",           icon: "text-pink-300",     dot: "bg-pink-400" },
  Black:    { chip: "bg-zinc-900 border-zinc-500/60 text-white",              icon: "text-zinc-200",    dot: "bg-zinc-300" },
  Elite:    { chip: "bg-fuchsia-500/20 border-fuchsia-400/60 text-fuchsia-50", icon: "text-fuchsia-300", dot: "bg-fuchsia-400" },
};

export default function AgilityTierChip() {
  const [t, setT] = useState(null);
  useEffect(() => { api.get("/me/tier").then((r) => setT(r.data)).catch(() => {}); }, []);
  if (!t) return null;

  const s = TIER_STYLE[t.tier] || TIER_STYLE.Silver;

  return (
    <div className="flex items-start gap-3 flex-wrap" data-testid="agility-tier-chip">
      <div className={`inline-flex items-center gap-2 h-10 px-4 rounded-full border ${s.chip} shadow-sm`}>
        <Award className={`w-4 h-4 ${s.icon}`} strokeWidth={2.5} />
        <span className="text-[11px] uppercase tracking-[0.2em] text-slate-300/80">Agility Tier</span>
        <span className={`w-1 h-1 rounded-full ${s.dot}`} />
        <span data-testid="tier-name" className="font-semibold text-sm tracking-wide">{t.tier}</span>
      </div>

      <div className="flex flex-col justify-center gap-0.5 text-xs">
        {t.is_max_tier ? (
          <span className="text-fuchsia-300">You're at the top tier. Keep going.</span>
        ) : (
          <span data-testid="tier-next-hint" className="text-slate-300">
            <span className="font-mono">{t.points_to_next.toLocaleString("en-IN")}</span> more points to reach <span className={s.icon + " font-medium"}>{t.next_tier}</span>.
          </span>
        )}
        <span className="flex items-center gap-1.5 text-[11px] text-slate-500">
          <Gift className="w-3 h-3" strokeWidth={2} />
          <span data-testid="tier-upgrade-note">{t.upgrade_note || "Each tier upgrade comes with a special gift from Veloskin."}</span>
        </span>
        {t.tier_benefits ? (
          <span data-testid="tier-benefits" className="text-[11px] text-emerald-300/90 mt-0.5">{t.tier_benefits}</span>
        ) : null}
      </div>
    </div>
  );
}
